import { useEffect, useState, useCallback, useRef } from 'react';
import classNames from 'classnames';
import Form, { Item as FormItem, GroupItem, ColCountByScreen, RequiredRule as Required, RangeRule as Range, StringLengthRule, CustomRule, PatternRule } from 'devextreme-react/form';
import dayjs from 'dayjs';
import FileUploader from 'devextreme-react/file-uploader';
import DateBox from 'devextreme-react/date-box';
import Validator, { RequiredRule } from 'devextreme-react/validator';
import GetFetch from '../../hooks/GetFetch';
import notify from 'devextreme/ui/notify';
import './BasicSecurityForm.scss';

// const fileExtensions = ['.csv'];

/** @typedef {import('../../types/basicSecurityData').BasicSecurityData} BasicSecurityData */

/**
 * @param {BasicSecurityData} data
 * @param {boolean} editing
 * @param {string} fileExtensions
 * @param {function(field, value): void} updateField
 */

export const BasicSecurityFormDetails = ({ data, editing, fileExtensions, updateField, updateObject }) => {

    const [formDataDefaults, setFormDataDefaults] = useState(data);
    
    const calendarOptions = {maxZoomLevel: 'decade', minZoomLevel: 'decade'};

    const onDataChanged = (field, newValue) => {
        setFormDataDefaults({ ...formDataDefaults, ...{ [field]: newValue } });
        updateField(field, newValue);
    };

    const onSaveClick = useCallback(() => {
        notify({
            message: `New contact "${newContactData.firstName} ${newContactData.lastName}" saved`,
            position: { at: 'bottom center', my: 'bottom center' }
        },
            'success'
        );
        setFormDataDefaults({ ...formDataDefaults });
    }, []);

    return (
        <Form className={classNames({ 'plain-styled-form': true, 'view-mode': !editing })}
            labelMode='floating'>
            <GroupItem caption='Upload Details' cssClass='basic-security-upload-group'>
                <FormItem>
                    <DateBox
                        // value={dayjs()}
                        calendarOptions={calendarOptions}
                        readOnly={!editing}
                        label="Fiscal Year"
                        inputAttr={{ class: 'form-editor-input' }}
                        stylingMode='filled'
                        displayFormat={"yyyy"}
                        dateSerializationFormat='yyyy-MM-dd'
                        placeholder='yyyy'
                        useMaskBehavior={true}
                        onValueChange={e => onDataChanged('BillDate', e)}
                        type='date'>
                        <Validator>
                            <RequiredRule message={'Fiscal Year is required'} />
                        </Validator>
                    </DateBox>
                </FormItem>
                <FormItem cssClass='accent' label='File Upload'>
                    <div className="fileuploader-container">
                        <span className="note">
                            Allowed file extensions: <span>{fileExtensions.join(" and ")}</span>.
                        </span>
                        <span className="note">
                            Maximum file size: <span>25 MB.</span>
                        </span>
                        <FileUploader
                            multiple={false}
                            uploadMode="useForm"
                            accept={fileExtensions.join(" ,")}
                            allowedFileExtensions={fileExtensions}
                            maxFileSize={25000000}
                            readOnly={!editing}
                            selectButtonText="Select File"
                            labelText="or Drop File Here"
                            onValueChanged={e => onDataChanged("UploadFile", e)}>
                        <Validator>
                            <RequiredRule message={'File is required'} />
                        </Validator>
                        </FileUploader>
                    </div>
                </FormItem>
            </GroupItem>
        </Form>
    );
};